import { useUpdateOptions, useSubscriptions } from '@mentimeter/billing';
import {
  mutateWorkspace,
  useInvalidateCurrentUserWorkspace,
} from '@mentimeter/workspace-data-hooks';
import { useCallback } from 'react';

export const useDataRefresh = () => {
  const { mutate: mutateUpdateOptions } = useUpdateOptions();
  const invalidateCurrentWorkspace = useInvalidateCurrentUserWorkspace();
  const { mutate: mutateSubscriptions } = useSubscriptions();
  const refreshAllData = useCallback(async () => {
    await mutateSubscriptions();
    await mutateWorkspace();
    await mutateUpdateOptions();
    await invalidateCurrentWorkspace();
  }, [mutateUpdateOptions, mutateSubscriptions, invalidateCurrentWorkspace]);

  return { refreshAllData };
};
